module.exports = __webpack_public_path__ + "static/media/seguros-mundial-logo.6fc800fa.svg";